<template>
  <output-preset-form
    v-if="
      !fetchingOutputPreset && !fetchingEmptyOutputPreset && checkedIfSystem
    "
    edit
    :submit-loading="editingOutputPreset"
    @submit="editOutputPreset"
  />
  <loading-page v-else />
</template>

<script>
import { mapGetters } from 'vuex'
import OutputPresetForm from './OutputPresetForm.vue'

import redirectError from '@/services/redirectError'

export default {
  name: 'EditOutputPreset',
  components: { OutputPresetForm },
  data() {
    return {
      checkedIfSystem: false,
    }
  },
  computed: {
    ...mapGetters('outputPresets', [
      'fetchingOutputPreset',
      'fetchingEmptyOutputPreset',
    ]),
    editingOutputPreset() {
      return this.$store.state.outputPresets.editingOutputPreset
    },
  },
  created() {
    this.getOutputPreset()
    this.getEmptyPreset()
  },
  methods: {
    getOutputPreset() {
      this.$store
        .dispatch('outputPresets/getOutputPresetById', this.$route.params.id)
        .then(res => {
          if (res.data.presetType === res.data.presetTypeOptions[0].id) {
            this.$router.push({ name: 'output-presets' })
          }
          this.checkedIfSystem = true
        })
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    getEmptyPreset() {
      this.$store
        .dispatch('outputPresets/getEmptyOutputPreset')
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    init() {
      this.getEmptyPreset()
      this.getOutputPreset()
    },
    editOutputPreset(e) {
      this.$store
        .dispatch('outputPresets/editOutputPreset', e)
        .then(() => {
          this.$router.push({
            name: 'output-presets',
            params: {
              toast: {
                title: 'Success',
                variant: 'success',
                message: 'Output preset updated successfully',
              },
            },
          })
        })
        .catch(() => {
          this.errorToast('An error occurred')
        })
    },
  },
}
</script>
